import { render } from "./CreateProformaInvoiceView.vue?vue&type=template&id=bf188030&scoped=true"
import script from "./CreateProformaInvoiceView.vue?vue&type=script&lang=js"
export * from "./CreateProformaInvoiceView.vue?vue&type=script&lang=js"

import "./CreateProformaInvoiceView.vue?vue&type=style&index=0&id=bf188030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf188030"]])

export default __exports__